import React from 'react'
import injectSheet from 'react-jss'
import {
  Cancel,
} from '../../icons/actionIcons'
import { IconButton } from '../../'

const AdminUserListItem = (props) => {
  const {
    classes,
    deleteUserMutation,
    user,
  } = props

  return (
    <div className={`${classes.item}`}>
      <div className={`${classes.content}`}>
        <div className={`${classes.name}`}>
          {user.lastName} {user.firstName}
        </div>
        <div className={`${classes.role}`}>
          {user.role}
        </div>
      </div>
      <div className={`${classes.actions}`}>
        {(user.role !== 'Admin' &&
          <IconButton
            handleClick={() => {
              deleteUserMutation({
                variables: { id: user.id },
              })
            }}
            icon={<Cancel />}
            index={0}
            primary
            modal
            modalText="Wollen Sie diesen Benutzer unwiderruflich löschen?"
            modalTitle="Benutzer löschen?"
            tip="löschen"
          />
        )}
      </div>
    </div>
  )
}

const styles = theme => ({
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: `${theme.sizes.gutter / 2}px`,
    margin: '2px 0',
    backgroundColor: theme.colors.main_2,
    borderWidth: '1px',
    borderColor: theme.colors.main_2,
    borderRadius: '3px',
    borderStyle: 'solid',
    color: theme.colors.main_3,
    transition: [
      {
        property: 'color',
        duration: theme.speed.fast,
      },
      {
        property: 'border-color',
        duration: theme.speed.fast,
      },
    ],
    '&:hover': {
      color: theme.colors.secondary_3b,
      borderColor: theme.colors.main_3,
    },
  },
  content: {
    display: 'flex',
    width: '100%',
  },
  name: {
    width: '60%',
  },
  role: {
    width: '40%',
  },
  actions: {
    width: '10%',
    display: 'flex',
    padding: `0 ${theme.sizes.gutter / 2}px`,
    '& > div': {
      margin: '0 2px',
    },
  },
})


export default injectSheet(styles)(AdminUserListItem)



// WEBPACK FOOTER //
// ./src/modules/admin/components/adminUserListItem.jsx